import { IconApproved, IconCancel } from 'assets/img';
import { PrimaryButton, SecondaryButton, useDialog } from 'ogp/providers/dialog-provider';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useGetDocumentForFw } from './use-find-document-for-fw';
import { IssueDocumentFormData } from '../../../../issue-document-form-content/issue-document-form-content.types';

export const useGetIssueDocumentDialog = () => {
  const { openDialog, closeDialog, enableDialog, disableDialog } = useDialog();
  const { watch } = useFormContext<IssueDocumentFormData>();
  const flexWorkerId = watch('flexWorkerOption')?.value ?? '';
  const documentType = watch('documentType');

  const { data } = useGetDocumentForFw(flexWorkerId, documentType);
  const isDocumentIssuedAlreadyForWorker = !!data;
  const { t } = useTranslation(['web-common', 'hq-screen-specific']);

  const titleDialog = isDocumentIssuedAlreadyForWorker
    ? t('document_create.confirmation_dialog_title_existing', { ns: 'hq-screen-specific' })
    : t('document_create.confirmation_dialog_title_new', { ns: 'hq-screen-specific' });

  const openDocumentDialog = (callback: () => void) => {
    openDialog(
      {
        title: titleDialog,
        secondaryButton: (props) => (
          <SecondaryButton iconColorMode="fill" startIcon={<IconCancel />} {...props}>
            {t('buttons.cancel', { ns: 'web-common' })}
          </SecondaryButton>
        ),
        primaryButton: (props) => (
          <PrimaryButton startIcon={<IconApproved />} {...props}>
            {t('buttons.confirm', { ns: 'web-common' })}
          </PrimaryButton>
        ),
      },
      () => {
        disableDialog();
        callback();
      }
    );
  };

  return {
    openDocumentDialog,
    closeDialog,
    enableDialog,
  };
};
